import SegmentedVideoPlayer from './SegmentedVideoPlayer';

export default SegmentedVideoPlayer;

export * from './types';
